var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-sticky',[_c('van-nav-bar',{attrs:{"title":_vm.title},scopedSlots:_vm._u([{key:"left",fn:function(){return [_c('van-icon',{attrs:{"name":"arrow-left"},on:{"click":_vm.onBack}})]},proxy:true},{key:"right",fn:function(){return [_c('van-icon',{attrs:{"badge":_vm.box,"name":"bag-o"},on:{"click":_vm.sepetegit}})]},proxy:true}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d230d57","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = null
// module chunks = 